import { FunctionComponent } from 'react'
import { OurIntlShape } from '@/i18n/typing'
import { PlatformShortcode } from '@/utils/convert-platform'

interface PlatformNameProps {
  platform: PlatformShortcode
  formatMessage: OurIntlShape['formatMessage']
}

const PlatformName: FunctionComponent<PlatformNameProps> = ({
  platform,
  formatMessage,
}) => {
  if (platform === PlatformShortcode.Instagram) {
    return 'Instagram'
  }
  if (platform === PlatformShortcode.Facebook) {
    return 'Facebook'
  }
  if (platform === PlatformShortcode.YouTube) {
    return 'Youtube'
  }
  if (platform === PlatformShortcode.Twitter) {
    return 'Twitter'
  }
  if (platform === PlatformShortcode.TikTok) {
    return 'Tiktok'
  }

  return formatMessage({ id: 'general:platform_custom' })
}

export default PlatformName
